import React from "react";
import PropTypes from "prop-types";
import classes from "./Header.module.scss";
import huronLogo from '@global-products/styles/images/huron-logo.svg';
import MILogo from "../../assets/img/Market_Insights_Logo.svg";
import { Link } from "react-router-dom";

/**
 * Pure component that displays the Header component
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
const HeaderView = ({
  userName,
  signOut
}) => {

  return (
    <div className={`${classes["header"]}`}>
      <Link to="/" title="Navigate to Home">
        <div className={`${classes["logos"]}`}>
          <img
            src={huronLogo}
            alt="Huron Logo"
            className={`${classes["huron-logo"]}`}
          />
          <div className={`${classes["logo-separator"]}`} />
          <img
            src={MILogo}
            alt="Market Insights Logo"
            className={`${classes["mi-logo"]}`}
          />
        </div>
      </Link>
      <div className={`float-right ${classes["header-elements"]}`}>
        <span className={`pr-4 ${classes["user-name"]}`}>
          <strong>Hello {userName || 'unnamed'}</strong>
        </span>
        <button type="button" onClick={signOut} className="button-primary">
          Sign Out
        </button>
      </div>
    </div>
  );
};

HeaderView.propTypes = {
  userName: PropTypes.string.isRequired,
  signOut: PropTypes.func.isRequired
};

export default HeaderView;
